import { FC, useContext, useMemo, useRef } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";
import { JobLineChart } from "@app/performance/job-statistics/JobLineChart";
import { JobStastiticsContext } from "@app/performance/job-statistics/JobStatisticsContext";
import { resizeChartToFitLabels } from "@app/performance/job-statistics/resizeChart";
import { UserDefinedChartModel } from "@app/performance/job-statistics/types";

interface UserDefinedJobLineChartWrapperProps {
    chartModel: UserDefinedChartModel;
}


export const UserDefinedJobLineChartWrapper: FC<React.PropsWithChildren<UserDefinedJobLineChartWrapperProps>> = (props: UserDefinedJobLineChartWrapperProps) => {
    const maxXAxisValue = useMemo(() => {
        return Math.max.apply(null, props.chartModel.dataPoints?.map((dp) => dp.xAxisValue));
    }, [props.chartModel.dataPoints]);
    const minXAxisValue = useMemo(() => {
        return Math.min.apply(null, props.chartModel.dataPoints?.map((dp) => dp.xAxisValue));
    }, [props.chartModel.dataPoints]);
    const context = useContext(JobStastiticsContext);
    const containerRef = useRef<HTMLSpanElement>(null);

    return (
        <span ref={containerRef}>
            {/* I thought a label would make sense for the chart's title, but WCAG specify a label should be associated with an input. So, span.*/}
            <span className="job-chart__title">{props.chartModel.metadata.name}</span>
            <QESButton
                className="job-chart__refresh"
                qesType="secondary"
                qesTestId={`job-chart__refresh-${props.chartModel.metadata.chartId}`}
                onClick={() => context.refreshUserDefinedChart(props.chartModel.metadata.chartId)}
            >
                <QesIcon iconName={QesIcons.RefreshCcwV2} description="Refresh chart" />
            </QESButton>
            <QESButton
                className="job-chart__resize"
                qesType="secondary"
                qesTestId={`job-chart__resize-${props.chartModel.metadata.chartId}`}
                onClick={() => resizeChartToFitLabels(containerRef.current)}
                disabled={props.chartModel.dataPoints.length === 0}
            >
                <QesIcon iconName={QesIcons.ArrowsVertical} description="Resize chart" />
            </QESButton>
            <QESButton
                className="job-chart__delete"
                qesType="secondary-danger"
                qesTestId={`job-chart__delete-${props.chartModel.metadata.chartId}`}
                onClick={() => context.deleteUserDefinedChart(props.chartModel.metadata.chartId)}
            >
                <QesIcon iconName={QesIcons.TrashV1} description="Delete chart" />
            </QESButton>
            <JobLineChart
                dataPoints={props.chartModel.dataPoints}
                yAxisLabel={props.chartModel.metadata.yAxis}
                domain={[minXAxisValue, maxXAxisValue]}
                xAxisLabel={props.chartModel.metadata.xAxis}
                errorMessage={props.chartModel.metadata.errorMessage}
            />
        </span>
    )
}
